import { format, fromUnixTime } from 'date-fns';
import { useState } from 'react';
import capitalizeFirstLetter from '../../common/functions/capitalizeFirstLetter';
import translate from '../../common/functions/translate';
import { usePageView } from '../../common/hooks/use.analytics';
import { usePageTitle } from '../../common/hooks/usePageTitle';
import DisplayAccountInfo from './DisplayAccountInfo';
import EnterUserInfoSection, { InitData } from './EnterUserInfoSection';
import NoAccountInRecords from './NoAccountInRecords';

interface FindMyAccountProps {
    initData?: InitData
}

export default function FindMyAccount(props: FindMyAccountProps) {
    const [page, setPage] = useState(0);
    const [userName, setUserName] = useState('');
    const [createdAt, setCreatedAt] = useState(0);

    usePageTitle(capitalizeFirstLetter(translate('find_my_account').toLowerCase()));
    usePageView('Find my account');

    const convertToDate = (timestamp: number) => {
        const date = fromUnixTime(timestamp);
        return format(date, 'MM/dd/yyyy');
    };

    const enterUserInfoSection = <EnterUserInfoSection
        initData={props.initData}
        showPageCallBack={(code) => setPage(code)}
        setUserName={setUserName}
        setCreatedAt={setCreatedAt}
    ></EnterUserInfoSection>;
    const displayAccountInfo = <DisplayAccountInfo userName={userName} createdAt={convertToDate(createdAt)} />;
    const noAccountInRecords = <NoAccountInRecords parentName={translate('find_my_account')}/>;

    const pages = [enterUserInfoSection, displayAccountInfo, noAccountInRecords];

    return pages[page];
}